import {
    Component,
    ChangeDetectionStrategy,
    Output,
    EventEmitter,
    Input,
    SimpleChanges,
    OnChanges,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IsavValidators } from '../../../utils/forms/validators';
import { PersonDto } from '../../../core/dto/person';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ChangesService } from '../../../core/changes-warning/changes.service';

@UntilDestroy()
@Component({
    selector: 'isav-people-edit-form',
    templateUrl: './people-edit-form.html',
    styleUrls: ['./people-edit-form.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleEditForm implements OnChanges, OnInit, OnDestroy {
    @Input() value: Partial<PersonDto>;
    @Output() save = new EventEmitter<Partial<PersonDto>>();
    @Output() wipe = new EventEmitter<void>();

    form = new UntypedFormGroup({
        fullName: new UntypedFormControl(null, [IsavValidators.required('Full name is required!')]),
        description: new UntypedFormControl('', [
            IsavValidators.required('Description is required!'),
        ]),
        phone: new UntypedFormControl(null, [IsavValidators.required('Phone is required!')]),
        userProfileType: new UntypedFormControl(null, [
            IsavValidators.required('User profile type is required!'),
        ]),
        organisationLink: new UntypedFormControl(null),
        address: new UntypedFormControl(null),
        zipcode: new UntypedFormControl(null),
        city: new UntypedFormControl(null),
        country: new UntypedFormControl(null, [IsavValidators.required('Country is required!')]),
        location: new UntypedFormControl(null, [
            IsavValidators.required('Location is required!'),
            IsavValidators.coordinates(),
        ]),
        fieldOfInterests: new UntypedFormControl(null),
        linksToCV: new UntypedFormControl(null),
        profileImage: new UntypedFormControl(null, [
            IsavValidators.required('Profile image is required!'),
        ]),
        organisation: new UntypedFormControl(null, [
            IsavValidators.required('You need to select organisation!'),
        ]),
        receivingNewsletter: new UntypedFormControl(null),
        gpdrConsented: new UntypedFormControl(null),
        expertises: new UntypedFormControl(
            null,
            IsavValidators.notEmpty('You must select at least one topic!')
        ),
    });

    constructor(private readonly changesService: ChangesService) {}

    ngOnInit() {
        this.changesService.connect(this.form);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && this.value) {
            this.form.reset(this.value);
        }
    }

    ngOnDestroy() {
        this.changesService.disconnect(this.form);
    }

    onSave() {
        this.form.reset(this.form.value);
        this.save.emit({
            ...this.form.value,
        });
    }

    onWipeData() {
        this.form.reset(this.form.value);
        this.wipe.emit();
    }
}
